var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsString, IsOptional, IsEnum, IsNumber, IsArray, Min } from 'class-validator';
export var IUCNStatus;
(function (IUCNStatus) {
    IUCNStatus["EXTINCT"] = "EX";
    IUCNStatus["EXTINCT_IN_WILD"] = "EW";
    IUCNStatus["CRITICALLY_ENDANGERED"] = "CR";
    IUCNStatus["ENDANGERED"] = "EN";
    IUCNStatus["VULNERABLE"] = "VU";
    IUCNStatus["NEAR_THREATENED"] = "NT";
    IUCNStatus["LEAST_CONCERN"] = "LC";
    IUCNStatus["DATA_DEFICIENT"] = "DD";
    IUCNStatus["NOT_EVALUATED"] = "NE";
})(IUCNStatus || (IUCNStatus = {}));
export var CITESStatus;
(function (CITESStatus) {
    CITESStatus["APPENDIX_I"] = "I";
    CITESStatus["APPENDIX_II"] = "II";
    CITESStatus["APPENDIX_III"] = "III";
    CITESStatus["NOT_LISTED"] = "NL";
})(CITESStatus || (CITESStatus = {}));
export class Species {
    constructor(data) {
        this.commonName = '';
        this.genus = '';
        this.species = '';
        this.typeCategory = '';
        this.originLocation = '';
        this.size = 0;
        this.weight = 0;
        this.colorDescription = '';
        this.captiveBreedingStatus = '';
        this.longevity = 0;
        this.recommendedHousing = '';
        this.diet = '';
        this.nestBoxSize = '';
        this.clutchSize = 0;
        this.fledgingAge = 0;
        this.hatchingPeriod = 0;
        this.iucnStatus = IUCNStatus.NOT_EVALUATED;
        this.citesStatus = CITESStatus.NOT_LISTED;
        Object.assign(this, data);
    }
    get fullTaxonomicName() {
        return `${this.genus} ${this.species}${this.subspecies ? ` ${this.subspecies}` : ''}`;
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], Species.prototype, "commonName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], Species.prototype, "genus", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], Species.prototype, "species", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Species.prototype, "subspecies", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], Species.prototype, "typeCategory", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], Species.prototype, "originLocation", void 0);
__decorate([
    IsNumber(),
    Min(0),
    __metadata("design:type", Number)
], Species.prototype, "size", void 0);
__decorate([
    IsNumber(),
    Min(0),
    __metadata("design:type", Number)
], Species.prototype, "weight", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], Species.prototype, "colorDescription", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], Species.prototype, "captiveBreedingStatus", void 0);
__decorate([
    IsNumber(),
    Min(0),
    __metadata("design:type", Number)
], Species.prototype, "longevity", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], Species.prototype, "recommendedHousing", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], Species.prototype, "diet", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], Species.prototype, "nestBoxSize", void 0);
__decorate([
    IsNumber(),
    Min(0),
    __metadata("design:type", Number)
], Species.prototype, "clutchSize", void 0);
__decorate([
    IsNumber(),
    Min(0),
    __metadata("design:type", Number)
], Species.prototype, "fledgingAge", void 0);
__decorate([
    IsNumber(),
    Min(0),
    __metadata("design:type", Number)
], Species.prototype, "hatchingPeriod", void 0);
__decorate([
    IsEnum(IUCNStatus),
    __metadata("design:type", String)
], Species.prototype, "iucnStatus", void 0);
__decorate([
    IsEnum(CITESStatus),
    __metadata("design:type", String)
], Species.prototype, "citesStatus", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], Species.prototype, "mutations", void 0);
